export function getByUser(list, user) {
    if (!user) return false
    return list.filter(item => item.user == user)
  }

export function getById(list, id) {
    if (!id) return false
    return list.filter(item => item.pk == id)
  }

export function getByCollective(list, collective, res = [] ) {
    if (!collective) return false
    Object.keys(list).forEach((image) => {
     list[image].collectives.forEach((item) => {
       if(item.name.toLowerCase() === collective) res.push(list[image])
      })
    })
    return res;
}

export function getByProject(list, project, res = [] ) {
  if (!project) return false
  Object.keys(list).forEach((image) => {
   list[image].projects.forEach((item) => {
     if(item.name.toLowerCase() === project) res.push(list[image])
    })
  })
  return res;
}

export function getByVoted(list) {
    return list.filter(item => item.voted == true)
  }